import React, { FC, ReactElement } from 'react';
import classNames from 'classnames/bind';
import { useUtils } from 'utils/hooks/useUtils';
import Image from 'next/image';
import styles from 'sections/Resources/FreightForwarder/landing/components/SectionPosts/components/Post/Post.module.scss';

const cn = classNames.bind(styles);

type PostProps = {
  image: any;
  date: string;
  title: string;
  url: string;
};

const Post: FC<PostProps> = ({ image, date, title, url }: PostProps): ReactElement => {
  const { convertDate } = useUtils();
  const formattedDate = convertDate(date);


  return (
    <div className={cn('post')}>
      <a className={cn('post__link')} href={`/blog/${url}`}>
        <div className={cn('post__image-box')}>
          {image && <Image src={image} alt="post image" width={337} height={200} />}
        </div>
        <div className={cn('post__content')}>
          <p className={cn('post__date')}>{formattedDate}</p>
          <h4 className={cn('post__heading')}>{title}</h4>
        </div>
      </a>
    </div>
  );
};

export { Post };
